'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  InfoBar: {
    displayName: 'InfoBar'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/InfoBar/InfoBar.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var InfoBar = _wrapComponent('InfoBar')((_dec = (0, _reactRedux.connect)(function (state) {
  return { info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ load: _info.load }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InfoBar, _Component);

  function InfoBar() {
    (0, _classCallCheck3.default)(this, InfoBar);
    return (0, _possibleConstructorReturn3.default)(this, (InfoBar.__proto__ || (0, _getPrototypeOf2.default)(InfoBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          info = _props.info,
          load = _props.load; // eslint-disable-line no-shadow

      var styles = require('./InfoBar.scss');
      return _react3.default.createElement(
        'div',
        { className: styles.infoBar + ' well' },
        _react3.default.createElement(
          'div',
          { className: 'container' },
          'This is an info bar',
          ' ',
          _react3.default.createElement(
            'strong',
            null,
            info ? info.message : 'no info!'
          ),
          _react3.default.createElement(
            'span',
            { className: styles.time },
            info && new Date(info.time).toString()
          ),
          _react3.default.createElement(
            'button',
            { className: 'btn btn-primary', onClick: load },
            'Reload from server'
          )
        )
      );
    }
  }]);
  return InfoBar;
}(_react2.Component), _class2.propTypes = {
  info: _react2.PropTypes.object,
  load: _react2.PropTypes.func.isRequired
}, _temp)) || _class));

exports.default = InfoBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoBar/InfoBar.js
// module id = 1179
// module chunks = 0